import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { AuthResponse } from '../../models/user/ciam-auth';
import { CiamUser } from '../../models/user/ciam-user';
import { environment } from '../../../../environments/environment';
import { GlobalService } from './../../services/global/global.service';
import { LocalStorageService } from './../../services/local-storage/local-storage.service';
import { SesionStorageService } from './../../services/sesion-storage/sesion-storage.service';
import { UserService } from './../../services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class LoggedInGuard  {

  constructor(private _global: GlobalService, private _storage: LocalStorageService, private _sesionStorage: SesionStorageService, private router: Router, private userService: UserService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.verifyLogin();
  }
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    return this.canActivate(route, state);
  }

  checkLogin(url: string): boolean {
    let dataSession:CiamUser = this._sesionStorage.getItemJSON(environment.CIAM_VAR_USERDATA);
    if(dataSession){
      return true;
    }else{
      this.router.navigate(['/login']);
      return false;
    }
  }

  verifyLogin(): boolean {

    if (localStorage.getItem(environment.CIAM_VAR_USERDATA)) {
      // let isExpired = this.isTokenExpired(localStorage.getItem(environment.CIAM_VAR_USERDATA));

      return true;
      // if(isExpired){
      //   this.router.navigate(['/login']);
      //   return false;
      // }else{
       // this.refreshToken();
      // }
    }

    this.router.navigate(['/login']);
    return false;
  }

  refreshToken(): boolean {
    const userData = localStorage.getItem(environment.CIAM_VAR_USERDATA);

    if (userData) {
      this.userService.refreshToken(userData).subscribe(
        (newToken) => {
          console.log('Token refreshed successfully');
        },
        (error) => {
          console.error('refreshTokenCIAM error:', error);
        }
      );
      return true;
    }

    console.warn('No user data found in localStorage.');
    return false;
  }


  getCiamAuthInfo() {
    return this._storage.parseItem<AuthResponse>(environment.CIAM_VAR_AUTHDATA);
  }


  getCiamUserInfo() {
    return this._sesionStorage.parseItem<CiamUser>(environment.CIAM_VAR_USERDATA);
  }


  isTokenExpired(token: string): boolean  {

    try {
      const decoded: any = jwtDecode(token);

      if (!decoded.exp) {
        return true; // Si no hay campo `exp`, se considera expirado
      }

      const currentTime = Math.floor(Date.now() / 1000); // Tiempo actual en segundos
      return decoded.exp < currentTime;
    } catch (error) {
      console.error('Error al decodificar el token:', error);
      return true; // Si ocurre un error, se considera expirado
    }
  }
}
